import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Paper from '@mui/material/Paper';
import { IconButton, FormControlLabel } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import LayersIcon from '@mui/icons-material/Layers';

const LayerControlOnMap = props => {
  const { baseMaps, layers, FindLayerVisible, ChageLayerVisible } = props;
  const [collapsed, setCollapsed] = React.useState(true);
  return (
    <Paper
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
      elevation={3}
    >
      {collapsed && (
        <IconButton>
          <LayersIcon fontSize="default" />
        </IconButton>
      )}
      {!collapsed && (
        <>
          <Accordion disableGutters>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Layers</Typography>
            </AccordionSummary>
            {layers.map(e => (
              <AccordionDetails key={e._id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={FindLayerVisible(e._id)}
                      onChange={() => ChageLayerVisible(e._id)}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label={e.name}
                />
              </AccordionDetails>
            ))}
          </Accordion>
          <Accordion disableGutters>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>BaseMap</Typography>
            </AccordionSummary>
            {baseMaps.map(e => (
              <AccordionDetails key={e._id}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={FindLayerVisible(e._id)}
                      onChange={() => ChageLayerVisible(e._id)}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label={e.name}
                />
              </AccordionDetails>
            ))}
          </Accordion>
        </>
      )}
    </Paper>
  );
};

LayerControlOnMap.propTypes = {
  baseMaps: PropTypes.array.isRequired,
  layers: PropTypes.array.isRequired,
  FindLayerVisible: PropTypes.func.isRequired,
  ChageLayerVisible: PropTypes.func.isRequired
};

export default LayerControlOnMap;
